import ParentRoute from './ParentRoute'
export default ParentRoute